/**
 * Font Awesome icon class (e.g. 'fas fa-utensils') for restaurant and store categories.
 * Unknown categories fall back to default.
 */

const RESTAURANT_ICONS = {
  Everything: 'fas fa-th-large',
  Aasia: 'fas fa-bowl-rice',
  Burgerit: 'fas fa-burger',
  Burritot: 'fas fa-burrito',
  Döner: 'fas fa-drumstick-bite',
  Eurooppa: 'fas fa-utensils',
  Falafel: 'fas fa-bowl-food',
  Grilli: 'fas fa-fire',
  Intia: 'fas fa-pepper-hot',
  Italia: 'fas fa-pizza-slice',
  Japani: 'fas fa-fish',
  Juomat: 'fas fa-wine-glass',
  Jälkiruoat: 'fas fa-ice-cream',
  Kahvi: 'fas fa-mug-hot',
  Kana: 'fas fa-drumstick-bite',
  Kansainvälinen: 'fas fa-globe',
  Kasvisruoka: 'fas fa-leaf',
  Kebab: 'fas fa-drumstick-bite',
  Keitot: 'fas fa-bowl-food',
  Kiina: 'fas fa-bowl-rice',
  Korea: 'fas fa-bowl-rice',
  Kreikka: 'fas fa-lemon',
  Kulhit: 'fas fa-utensils',
  Kuplatee: 'fas fa-cake-candles',
  Leipomo: 'fas fa-bread-slice',
  'Lähi-Itä': 'fas fa-bowl-food',
  Meksiko: 'fas fa-pepper-hot',
  Nepali: 'fas fa-bowl-rice',
  Nuudelit: 'fas fa-bowl-food',
  Nyytit: 'fas fa-utensils',
  Pasta: 'fas fa-bowl-food',
  Pihvi: 'fas fa-drumstick-bite',
  Pizza: 'fas fa-pizza-slice',
  Ramen: 'fas fa-bowl-food',
  Salaatti: 'fas fa-leaf',
  Suomi: 'fas fa-utensils',
  Sushi: 'fas fa-fish',
  Taco: 'fas fa-burrito',
  Thaimaa: 'fas fa-bowl-rice',
  'Täytetyt leivät': 'fas fa-bread-slice',
  USA: 'fas fa-burger',
  Vegaaninen: 'fas fa-leaf',
  Vietnam: 'fas fa-bowl-rice',
  Wings: 'fas fa-drumstick-bite',
  Wrapit: 'fas fa-burrito',
  Food: 'fas fa-utensils',
  'Wine & Liquor': 'fas fa-wine-glass',
  Coffee: 'fas fa-mug-hot',
  'Virtual Brands': 'fas fa-store',
  Other: 'fas fa-utensils'
};

const STORE_ICONS = {
  Everything: 'fas fa-th-large',
  Electronics: 'fas fa-laptop',
  Clothing: 'fas fa-shirt',
  Groceries: 'fas fa-basket-shopping',
  'Home & Garden': 'fas fa-house',
  'Beauty & Health': 'fas fa-spa',
  Sports: 'fas fa-futbol',
  Books: 'fas fa-book',
  Toys: 'fas fa-gamepad',
  'Pet Supplies': 'fas fa-paw',
  Other: 'fas fa-store'
};

const RESTAURANT_DEFAULT = 'fas fa-utensils';
const STORE_DEFAULT = 'fas fa-store';

export function getRestaurantCategoryIcon(category) {
  return RESTAURANT_ICONS[category] || RESTAURANT_DEFAULT;
}

export function getStoreCategoryIcon(category) {
  return STORE_ICONS[category] || STORE_DEFAULT;
}
